export default __webpack_public_path__ + "static/media/datos_cifras_estadisticas.1ae4e0a3.pdf";